/**
 * Crisis alerts
 */

(() => {
    let container = document.querySelector(
        '.js-crisis-alert-sitewide-container'
    );
    let alerts = document.querySelectorAll('.js-crisis-alert');
    let buttons = document.querySelectorAll('.js-crisis-alert-close-button');

    // validate
    if (!container || !alerts.length || !buttons.length) {
        // console.log('Invalid args');
        return;
    }

    function updateAlertStates() {
        let hasOpenAlerts = false;

        alerts.forEach((alert) => {
            const hash = alert.getAttribute('data-hash');
            if (!hash) {
                return;
            }

            const closed = localStorage.getItem('crisisAlertClosed-' + hash);
            if (closed) {
                alert.classList.add('-closed');
            } else {
                alert.classList.add('-open');
                hasOpenAlerts = true;
            }
        });

        container.classList.toggle('-has-open-alerts', hasOpenAlerts);
        container.classList.toggle('-no-open-alerts', !hasOpenAlerts);
        document.documentElement.classList.toggle(
            '-is-crisis-alert-open',
            hasOpenAlerts
        );
    }

    function closeCrisisAlert() {
        // console.log('Closing crisis alert');

        let alert = this.closest('.js-crisis-alert');
        if (!alert) {
            return;
        }

        const hash = alert.getAttribute('data-hash');
        if (!hash) {
            return;
        }

        // Hide alert with this hash
        localStorage.setItem('crisisAlertClosed-' + hash, true);
        alert.classList.add('-closed');
        alert.classList.remove('-open');

        updateAlertStates();
    }

    function init() {
        updateAlertStates();

        // Add close button listeners
        buttons.forEach((button) => {
            button.addEventListener('click', closeCrisisAlert);
        });
    }

    init();
})();
